import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import {
  emptyNetworkOrganizationForm,
  networkOrganizationFields,
} from "./NetworkOrganizationForm";
import NetworkOrganizationForm from "./NetworkOrganizationForm";
import { createNetworkOrganization } from "./networkApi";

const NetworkOrganizationCreate = () => {
  const { networkId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [form, setForm] = useState(emptyNetworkOrganizationForm);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const listPath = `/app/network/${networkId}/organizations`;

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (!networkOrganizationFields.includes(name)) return;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!form.name.trim()) nextErrors.name = "School name is required.";
    if (!form.email.trim()) nextErrors.email = "Email is required.";
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;

    setSaving(true);
    try {
      await createNetworkOrganization(networkId, form);
      toast({ title: "School created", status: "success", duration: 3000, isClosable: true });
      navigate(listPath);
    } catch (error) {
      console.error("Error creating network organization:", error);
      toast({ title: "Could not create school", status: "error", duration: 4000, isClosable: true });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box p={{ base: 4, md: 6 }} maxW="container.md" mx="auto">
      <Heading size="lg">Add school</Heading>
      <Text color="gray.500" mb={5}>Create a school in this network.</Text>

      <NetworkOrganizationForm
        form={form}
        errors={errors}
        isSubmitting={saving}
        submitLabel="Create"
        onCancel={() => navigate(listPath)}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};

export default NetworkOrganizationCreate;
